import * as ActionTypes from 'constants/ActionTypes';

export function setInstance(instance) {
  return { type: ActionTypes.JAWS_SET_INSTANCE, instance };
}

export function connectionEstablished() {
  return { type: ActionTypes.JAWS_CONNECTION_ESTABLISHED };
}

export function connectionClosed() {
  return { type: ActionTypes.JAWS_CONNECTION_CLOSED };
}
